import { render, staticRenderFns } from "./LimitModal.vue?vue&type=template&id=155908a4&scoped=true&"
import script from "./LimitModal.vue?vue&type=script&lang=js&"
export * from "./LimitModal.vue?vue&type=script&lang=js&"
import style0 from "./LimitModal.vue?vue&type=style&index=0&id=155908a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155908a4",
  null
  
)

export default component.exports